/**
 * Constantes partagées de Panda Panic en ligne (Phase 4 — spec 15 §6, ADR 0022).
 * Le client (`apps/web`) et le serveur autoritaire (`apps/game-server`) s'y
 * réfèrent pour parler le MÊME protocole. Aucune donnée secrète ni cachée ici
 * (ADR 0003) : rien de ce fichier ne renseigne un client sur l'état de jeu.
 */

/** Slug du jeu — DOIT rester aligné sur `PANDA_PANIC_META.id` (game-logic) et la route front. */
export const PANDA_PANIC_SLUG = 'panda-panic' as const;
export type PandaPanicSlug = typeof PANDA_PANIC_SLUG;

/** Nom de salle Colyseus : `gameServer.define(PANDA_PANIC_ROOM, …)` / `client.joinById(...)`. */
export const PANDA_PANIC_ROOM = 'panda_panic' as const;

/** Bornes de sièges — DOIVENT correspondre à `PANDA_PANIC_META` (game-logic, vérifié en test). */
export const PANDA_PANIC_MIN_PLAYERS = 2 as const;
export const PANDA_PANIC_MAX_PLAYERS = 4 as const;

/** Longueur du code de salle (§6 : « création → code à 4 lettres »). */
export const PANDA_PANIC_ROOM_CODE_LENGTH = 4 as const;

/**
 * Émetteur/audience du JWT de connexion. L'audience distincte est une
 * allowlist : un jeton émis pour un autre usage (session, reauth…) ne rejoint
 * jamais une salle, et vice-versa.
 */
export const PANDA_PANIC_JWT_ISSUER = 'redpandev-api' as const;
export const PANDA_PANIC_JWT_AUDIENCE = 'panda-panic-game-server' as const;

/** Unique algorithme accepté (allowlist anti alg-confusion / `alg: none`). Secret partagé → HMAC. */
export const PANDA_PANIC_JWT_ALG = 'HS256' as const;

/** TTL court du jeton (s) : l'API l'émet, le client rejoint aussitôt (§6). */
export const PANDA_PANIC_JWT_TTL_SECONDS = 120 as const;
